import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../sidebar-component';
import SidebarComponentHeader from '../sidebar/sidebar-component-header';
import Keyword from '../sidebar/keyword';

const KeywordsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function Keywords({ data, relation, query }) {
  if (!_.get(data, 'keywords.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title={`${data.keywords.length > 1 ? 'keywords' : 'keyword'} ${relation}`}
        query={query}
      />
      <KeywordsContainer>
        {data.keywords.map(kw => <Keyword key={`kw-${kw.id}`} keyword={kw} />)}
      </KeywordsContainer>
    </SidebarComponent>
  );
}

Keywords.propTypes = {
  data: PropTypes.shape({
    keywords: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  }),
  relation: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
};

Keywords.defaultProps = {
  data: null,
};
